var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    d: "M4.7 4c0-1.5 1.2-2.8 2.8-2.8h8c1.5 0 2.8 1.2 2.8 2.8v12c0 1.5-1.2 2.8-2.8 2.8h-8c-1.5 0-2.8-1.2-2.8-2.8V4zm2.8-1.2c-.7 0-1.3.5-1.3 1.2v12c0 .7.6 1.2 1.2 1.2h8c.7 0 1.3-.6 1.3-1.2V4c0-.7-.6-1.2-1.3-1.2H7.5zm0 18.4c0-.4.3-.8.8-.8h6.5c.4 0 .8.3.8.8s-.4.8-.9.8H8.2c-.4 0-.7-.3-.7-.8z",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    d: "M7.1 17.5c.3.2.4.7.2 1L4 22.9c-.2.3-.7.4-1.1.1-.3-.2-.4-.7-.2-1L6 17.6c.3-.3.8-.4 1.1-.1zm8.8 0c-.3.2-.4.7-.1 1l3.3 4.4c.2.3.7.4 1 .1.3-.2.4-.7.2-1L17 17.6c-.3-.3-.8-.4-1.1-.1zM9.5 14c0 .6-.4 1-1 1s-1-.4-1-1 .4-1 1-1c.5 0 1 .4 1 1zm6 0c0 .6-.4 1-1 1s-1-.4-1-1 .4-1 1-1c.5 0 1 .4 1 1zm-8-8c0-.6.4-1 1-1h6c.6 0 1 .4 1 1v4c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1V6z",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransit);
export default __webpack_public_path__ + "static/media/Transit.032ada91bf78fda66af95b628d3b678e.svg";
export { ForwardRef as ReactComponent };